import { render, staticRenderFns } from "./SmallInfoBox.vue?vue&type=template&id=62e0d223&scoped=true"
import script from "./SmallInfoBox.vue?vue&type=script&lang=js"
export * from "./SmallInfoBox.vue?vue&type=script&lang=js"
import style0 from "./SmallInfoBox.vue?vue&type=style&index=0&id=62e0d223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0d223",
  null
  
)

export default component.exports